/** @format */

import React, { useEffect, useRef, useState } from "react";
import "../Style/damtable.css";
import TooltipInfoBox from "./TooltipInfoBox";

export default function DamPnLTable({
  damData,
  Total,
  STRIKE,
  QUANTITY,
  VOLUME,
}) {
  const [hasScroll, setHasScroll] = useState(false);

  const scrollRef = useRef(null);

  useEffect(() => {
    const checkScroll = () => {
      if (scrollRef.current) {
        setHasScroll(
          scrollRef.current.scrollHeight > scrollRef.current.clientHeight
        );
      }
    };
    checkScroll();
    window.addEventListener("resize", checkScroll);
    return () => window.removeEventListener("resize", checkScroll);
  }, [damData]);

  const tableData = damData.map((row) => {
    const dateObj = new Date(row.date);
    const MCP = row.avgMCP;
    const diff = +(MCP - STRIKE).toFixed(2);

    // Υπολογισμός ωρών της μέρας (25 για 26-10-2025, 24 για τις υπόλοιπες)
    const isDstChangeDay = row.date === "2025-10-26";
    const hoursInDay = isDstChangeDay ? 25 : 24;

    const value = +(diff * QUANTITY * hoursInDay).toFixed(2);

    return {
      date: dateObj.toLocaleDateString("el-GR"),
      MCP,
      diff,
      value,
      hoursInDay, // προσθέτουμε για να το δείχνουμε στον πίνακα αν θέλεις
    };
  });

  return (
    <div className="container">
      <div className="title-with-tooltip">
        <h2>DAM Daily Average Price</h2> <TooltipInfoBox />
      </div>
      <div className="table-wrapper">
        {/* Head Table */}
        <table>
          <thead>
            <tr>
              <th>Date</th>
              <th>MCP</th>
              <th>Strike</th>
              <th>Volume</th>
              <th>Quantity</th>
              <th>Difference</th>
              <th>Value (€)</th>
              {hasScroll && <td className="scroll-fix2">&nbsp;</td>}
            </tr>
          </thead>
        </table>

        {/* Scrollable Body */}
        <div className="scrollable-body" ref={scrollRef}>
          <table>
            <tbody>
              {tableData.map((row, i) => (
                <tr key={i}>
                  <td>{row.date}</td>
                  <td>{row.MCP.toFixed(2)}</td>
                  <td>{STRIKE}</td>
                  <td>{VOLUME}</td>
                  <td>{QUANTITY * row.hoursInDay}</td>
                  <td className={row.diff >= 0 ? "green" : "red"}>
                    {row.diff.toFixed(2)}
                  </td>
                  <td
                    className={row.value >= 0 ? "green" : "red"}
                    style={{
                      backgroundColor: row.value >= 0 ? "#d9fdd3" : "#f8d7da",
                      fontWeight: 600,
                      textAlign: "center",
                      paddingRight: 8,
                    }}
                  >
                    {row.value.toLocaleString("el-GR", {
                      style: "currency",
                      currency: "EUR",
                      minimumFractionDigits: 2,
                    })}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {/* Σταθερό Σύνολο */}
        <div className="total-row-wrapper">
          <table>
            <tfoot>
              <tr>
                <td
                  colSpan={6}
                  style={{
                    paddingRight: "33px",
                    textAlign: "right",
                    fontWeight: "bold",
                  }}
                >
                  Total
                </td>
                <td
                  className={Total >= 0 ? "green" : "red"}
                  style={{
                    fontWeight: 600,
                    padding: "4px",
                    backgroundColor: Total >= 0 ? "#d9fdd3" : "#f8d7da",
                  }}
                >
                  {Total.toLocaleString("el-GR", {
                    style: "currency",
                    currency: "EUR",
                    minimumFractionDigits: 2,
                  })}
                </td>
                {hasScroll && <td className="scroll-fix" />}
              </tr>
            </tfoot>
          </table>
        </div>
      </div>
    </div>
  );
}
